import { useEffect } from "react";

export default function useSaveFilterOnReload(key, formik) {
  // Load saved values when component mounts
  useEffect(() => {
    const saved = localStorage.getItem(key);
    if (saved) {
      const values = JSON.parse(saved);
      formik.setValues(values); // Restore filters
    }
  }, []);

  // Save whenever Formik values change
  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(formik.values));
  }, [formik.values]);
}
